/**
 * Parses a JSON string defensively, returning `null` on empty input or a parse failure instead of
 * throwing. Intended for backend-supplied free-form JSON fields (e.g. `NotificationDto.payload`) whose
 * shape should never crash the UI even if it's missing or malformed.
 */
export function safeJsonParse<T>(json: string | null | undefined): T | null {
  if (!json) {
    return null;
  }

  try {
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
